import * as React from 'react';
import {
  WrapperStep,
  WrapperStepLeft,
  Overlay,
  WrapperStepRight,
  Container,
  Wrapper
} from './styled';

interface Props {
  children: React.ReactNode;
  alias: string;
}

export const StepContainer: React.FC<Props> = ({ children, alias }) => (
  <WrapperStep>
    <WrapperStepLeft alias={alias}>
      <Overlay alias={alias} />
    </WrapperStepLeft>
    <WrapperStepRight>
      <Container>
        <Wrapper>
          {children}
        </Wrapper>
      </Container>
    </WrapperStepRight>
  </WrapperStep>
);
